import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="footerContainer">
        <p className="footerText">
          For additional help, please contact a staff member at your respective
          facility.
        </p>
        <div>
          <img src="/centara.png" alt="Logo" className="footerLogo" />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
